import React from "react"
import StepShell from "./onboarding/StepShell.jsx"
import CreateShopStep from "./onboarding/CreateShopStep.jsx"
import StartCrawlStep from "./onboarding/StartCrawlStep.jsx"
import CrawlingStep from "./onboarding/CrawlingStep.jsx"
import ReviewPagesStep from "./onboarding/ReviewPagesStep.jsx"
import DefineConversionStep from "./onboarding/DefineConversionStep.jsx"
import AnalyzingStep from "./onboarding/AnalyzingStep.jsx"
import InstallScriptStep from "./onboarding/InstallScriptStep.jsx"
import FailedStep from "./onboarding/FailedStep.jsx"

const STEPS = [ "create", "start_crawl", "crawling", "review", "define_conversion", "analyzing", "install_script" ]

function pickStep({ shop, profile }) {
  if (!shop) return "create"
  if (profile?.crawl_status === "failed") return "failed"
  if (shop.status === "active") return "install_script"
  if (shop.status === "onboarding") return "analyzing"
  if (shop.status === "crawled") {
    const setting = shop.setting || {}
    if (setting.pages_reviewed_at) return "define_conversion"
    return "review"
  }
  if (profile?.crawl_status === "crawling") return "crawling"
  return "start_crawl"
}

export default function Onboarding({ t, shopState }) {
  const { status, shop, profile, error, refresh } = shopState

  if (status === "loading") {
    return (
      <StepShell t={t} stepKey="create" current={1} total={STEPS.length}>
        <p className="text-sm text-ink-tertiary">Loading…</p>
      </StepShell>
    )
  }

  if (status === "error") {
    return (
      <StepShell t={t} stepKey="failed" current={1} total={STEPS.length}>
        <p className="text-sm text-ink-secondary">{error}</p>
      </StepShell>
    )
  }

  const stepKey = pickStep({ shop, profile })
  const current = Math.max(1, STEPS.indexOf(stepKey) + 1)

  const shell = (body, maxWidth) => (
    <StepShell t={t} stepKey={stepKey} current={current} total={STEPS.length} maxWidth={maxWidth}>
      {body}
    </StepShell>
  )

  switch (stepKey) {
    case "create":            return shell(<CreateShopStep t={t} onCreated={refresh} />)
    case "start_crawl":       return shell(<StartCrawlStep t={t} shop={shop} onStarted={refresh} />)
    case "crawling":          return shell(<CrawlingStep t={t} shop={shop} profile={profile} />)
    case "review":            return shell(<ReviewPagesStep t={t} profile={profile} onReviewed={refresh} />, "max-w-4xl")
    case "define_conversion": return shell(<DefineConversionStep t={t} profile={profile} onContinued={refresh} />, "max-w-4xl")
    case "analyzing":         return shell(<AnalyzingStep t={t} profile={profile} />)
    case "install_script":    return shell(<InstallScriptStep t={t} shop={shop} />)
    case "failed":            return shell(<FailedStep t={t} onRetry={refresh} />)
    default:                  return shell(null)
  }
}
